import React from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'

import AuthenticatedLayout from '../components/layouts/AuthenticatedLayout'
import ProtectedRoute from './ProtectedRoute'
import Specialities from '../pages/HIS/Specialities'
import { useSelector } from 'react-redux'
import SupplyChainDashboard from '../components/his/inventory/SupplyChainDashboard'
import PriceListViewPage from '../components/his/price-list/PriceListViewPage'
import InPatientMain from '../pages/HIS/patient-profiling/InPatientMain'
import LabOrders from '../pages/HIS/LabOrders'
import ViewLabOrder from '../components/Laborders/ViewLabOrder'
import DoctorWiseReport from '../pages/HIS/DoctorWiseReport'
import DoctorScheduleReport from '../pages/HIS/DoctorScheduleReport'
import Settings from '../pages/HIS/Settings'
import MedicalReportSettings from '../pages/HIS/MedicalReportSettings'
import VisitHistory from '../pages/HIS/VisitHistory'
import VisitHistoryDetailPage from '../pages/HIS/VisitHistoryDetailPage'
import TrackingPage from '../components/Laborders/TrackingPage'
import ClaimGeneration from '../pages/HIS/ClaimGeneration'
import PharmacyClaimGeneration from '../pages/HIS/PharmacyClaimGeneration'
import BulkClaimsBatches from '../components/his/claimgeneration/BulkClaimsBatches'
import Claims from '../pages/HIS/Claims'
import ClaimBatchDetails from '../pages/HIS/ClaimBatchDetails'
import UserCollectionReport from '../pages/HIS/UserCollectionReport'
import InvoiceReport from '../pages/HIS/InvoiceReport'
import RadiologyOrders from '../pages/HIS/RadiologyOrders'
import QueueDashboard from '../components/his/queue-management/QueueDashboard'
import CreateWithoutSlot from '../pages/HIS/CreateWithoutSlot'
import PatientActiveOrders from '../pages/HIS/PatientActiveOrders'
import DoctorDepartmentSummaryReport from '../pages/HIS/DoctorDepartmentSummaryReport'
import AppointmentHistoryPage from '../components/his/appointments/AppointmentHistoryPage'
import ProfileAppointments from '../components/his/appointments/ProfileAppointments'
import ProfileVisits from '../pages/HIS/ProfileVisits'
// NEW REFACTORED REPORTS - Support multiple concurrent jobs
import PayersSummaryReport from '../pages/HIS/reports/insurance/PayersSummaryReportAsyncNew'
import PayerReport from '../pages/HIS/reports/insurance/PayerReport'
import PolicyReport from '../pages/HIS/reports/insurance/PolicyReportAsyncNew'
import PreClaimSubmissionReport from '../pages/HIS/reports/insurance/PreClaimSubmissionReport'
import PatientReports from '../pages/HIS/PatientReports'
import DrsPatientReport from '../pages/HIS/reports/patient/DrsPatientReport'
import DrsPatientItemWiseReportAsync from '../pages/HIS/reports/patient/DrsPatientItemWiseReportAsync'
import DepartmentWisePatientReport from '../pages/HIS/reports/patient/DepartmentWisePatientReport'
import EMRReport from '../pages/HIS/EmrReports'
import ClaimList from '../pages/HIS/ClaimList'
import EditClaim from '../components/his/claimgeneration/EditClaim'
import ClaimDetails from '../pages/HIS/ClaimDetails'
import ApprovalManagement from '../pages/HIS/ApprovalManagement'
import EmrHistoryPage from '../pages/HIS/EmrHistoryPage'
import InvoiceAuditPage from '../pages/HIS/InvoiceAuditPage'
import ItemWiseSummaryReport from '../pages/HIS/reports/emr/ItemWiseSummaryReportAsyncNew'
import ItemWiseDetailedReport from '../pages/HIS/reports/emr/ItemWiseDetailedReportAsyncNew'
import LabRadiologySummaryReport from '../pages/HIS/reports/emr/LabRadiologySummaryReportAsync'
import LabRadiologyItemWiseReport from '../pages/HIS/reports/emr/LabRadiologyItemWiseReportAsync'
import PatientAnalysisReport from '../pages/HIS/reports/emr/PatientAnalysisReportAsync'
import SalesDateWiseReport from '../pages/HIS/reports/emr/SalesDateWiseReportAsync'
import RefundReport from '../pages/HIS/reports/emr/RefundReportAsync'
import PractitionerItemSummaryReport from '../pages/HIS/reports/emr/PractitionerItemSummaryReportAsyncNew'
import ResidentialReport from '../pages/HIS/reports/emr/ResidentialReportAsyncNew'
import ApprovalReport from '../pages/HIS/reports/emr/ApprovalReportAsyncNew'
import NotApprovedAuditsReport from '../components/his/billingReports.js/NotApprovedAuditsReport'
import ExternalPharmacySalesReportAsync from '../components/his/billingReports.js/ExternalPharmacySalesReportAsync'
import InternalPharmacySalesReportAsync from '../components/his/billingReports.js/InternalPharmacySalesReportAsync'
const PayerStatsReport = React.lazy(() =>
  import('../pages/HIS/PayerStatsReport')
)
const ReferralCertificatePage = React.lazy(() =>
  import('../pages/HIS/patient-profiling/ReferralCertificatePage')
)
const AttendanceCertificatePage = React.lazy(() =>
  import('../pages/HIS/patient-profiling/AttendanceCertificatePage')
)
const FitToTravelPage = React.lazy(() =>
  import('../pages/HIS/patient-profiling/FitToTravelPage')
)
const AccompanyCertificatePage = React.lazy(() =>
  import('../pages/HIS/patient-profiling/AccompanyCertificatePage')
)
const EmrNewMedicalReportPage = React.lazy(() =>
  import('../pages/HIS/patient-profiling/reports/EmrNewMedicalReport')
)
const FitToRejoinPage = React.lazy(() =>
  import('../pages/HIS/patient-profiling/FitToRejoinPage')
)
const LabReportPage = React.lazy(() =>
  import('../components/reports/LabReportPage')
)
const RadiologyReportPage = React.lazy(() =>
  import('../components/reports/RadiologyReportPage')
)
const HighBmiPatientReport = React.lazy(() =>
  import('../components/reports/HighBmiPatientReport')
)
const NoShowPatientReport = React.lazy(() =>
  import('../components/reports/NoShowPatientReport')
)
const VaccineStatusReport = React.lazy(() =>
  import('../components/reports/VaccineStatusReport')
)
const ICDInactiveReportPage = React.lazy(() =>
  import('../components/reports/ICDInactiveReportPage')
)
const IcdInactiveReportManager = React.lazy(() =>
  import('../components/reports/IcdInactiveReportManager')
)
const IcdReportsTest = React.lazy(() =>
  import('../components/reports/IcdReportsTest')
)
const ICDBulkReplacePage = React.lazy(() =>
  import('../components/reports/ICDBulkReplacePage')
)
const ICDBulkReplaceLogsPage = React.lazy(() =>
  import('../components/reports/ICDBulkReplaceLogsPage')
)
const ItemFieldReplacePage = React.lazy(() =>
  import('../components/reports/ItemFieldReplacePage')
)
const ItemFieldReplaceCreatePage = React.lazy(() =>
  import('../components/reports/ItemFieldReplaceCreatePage')
)

const ReturnToVendor = React.lazy(() =>
  import('../components/his/inventory/ReturnToVendorForm')
)
const StockManage = React.lazy(() =>
  import('../components/his/inventory/stock/StockManage')
)
const DirectDispatchFrom = React.lazy(() =>
  import('../components/his/inventory/DirectDispatchFrom')
)
const PurchaseRequestForm = React.lazy(() =>
  import('../components/his/inventory/PurchaseRequestForm')
)
const DonateForm = React.lazy(() =>
  import('../components/his/inventory/DonateForm')
)
const FmsOperations = React.lazy(() => import('../pages/HIS/FmsOperations'))
const Department = React.lazy(() => import('../pages/HIS/Department'))
const RequestQuotation = React.lazy(() =>
  import('../components/his/Procurement/RequestQuotation')
)
const BioMedical = React.lazy(() => import('../pages/HIS/BioMedical'))
const Procurement = React.lazy(() => import('../pages/HIS/Procurement'))
const AddPurchaseOrder = React.lazy(() =>
  import('../components/his/Procurement/AddPurchaseOrder')
)
const AddReciept = React.lazy(() =>
  import('../components/his/Procurement/AddReciept')
)

const OrderDetails = React.lazy(() => import('../pages/HIS/OrderDetails'))
const Vaccination = React.lazy(() => import('../pages/HIS/Vaccination'))
const Billing = React.lazy(() => import('../pages/HIS/Billing'))
const PatientsDepositList = React.lazy(() =>
  import('../pages/HIS/PatientsDepositList')
)
const PatientsCreditList = React.lazy(() =>
  import('../pages/HIS/PatientsCreditList')
)
const Orders = React.lazy(() => import('../pages/HIS/Orders'))
const CreateOrder = React.lazy(() => import('../pages/HIS/CreateOrder'))
const CreateSpecialVisit = React.lazy(() =>
  import('../pages/HIS/CreateSpecialVisit')
)
const PatientProfilingLayout = React.lazy(() =>
  import('../components/layouts/PatientProfilingLayout')
)
const HelpDesk = React.lazy(() => import('../pages/HIS/HelpDesk'))
const CSSD = React.lazy(() => import('../pages/HIS/CSSD'))
const MedicalRecords = React.lazy(() => import('../pages/HIS/MedicalRecords'))
const OperationTheatre = React.lazy(() =>
  import('../pages/HIS/OperationTheatre')
)
const WardManagement = React.lazy(() => import('../pages/HIS/WardManagement'))
const ReceptionDashboard = React.lazy(() =>
  import('../pages/HIS/ReceptionDashboard')
)
const SystemHealthDashboard = React.lazy(() =>
  import('../pages/HIS/SystemHealthDashboard')
)
const MinioManager = React.lazy(() => import('../pages/HIS/MinioManager'))
const CreateVisits = React.lazy(() => import('../pages/HIS/CreateVisit'))
const Visits = React.lazy(() => import('../pages/HIS/Visits'))
const Beneficiary = React.lazy(() => import('../pages/HIS/Beneficiary'))
const PatientBulkUpload = React.lazy(() =>
  import('../pages/HIS/PatientBulkUpload')
)
const CreateBeneficiary = React.lazy(() =>
  import('../pages/HIS/CreateBeneficiary')
)
const BeneficiaryDetails = React.lazy(() =>
  import('../pages/HIS/BeneficiaryDetails')
)
const Eligibility = React.lazy(() => import('../pages/HIS/Eligibility'))
const Physicians = React.lazy(() => import('../pages/HIS/Physicians'))
const Payers = React.lazy(() => import('../pages/HIS/Payers'))
const PayerPolicyBenefits = React.lazy(() =>
  import('../pages/HIS/PayerPolicyBenefits')
)
const PolicyBenefits = React.lazy(() =>
  import('../pages/HIS/PolicyBenefits')
)
const Drivers = React.lazy(() => import('../pages/HIS/Drivers'))
const Nurses = React.lazy(() => import('../pages/HIS/Nurses'))
const InsurancePolicy = React.lazy(() => import('../pages/HIS/InsurancePolicy'))
const PriceLists = React.lazy(() => import('../pages/HIS/PriceLists'))
const CreatePriceList = React.lazy(() => import('../pages/HIS/CreatePriceList'))
const PriceListAuditHistory = React.lazy(() =>
  import('../pages/HIS/PriceListAuditHistory')
)
const FormsCreation = React.lazy(() => import('../pages/HIS/FormCreationNew'))
const DynamicFormsList = React.lazy(() =>
  import('../pages/HIS/DynamicFormsList')
)
const ViewFormDetails = React.lazy(() => import('../pages/HIS/ViewFormDetails'))
const Staff = React.lazy(() => import('../pages/HIS/Staff'))
const StaffFormPage = React.lazy(() => import('../pages/HIS/StaffFormPage'))
const AdminActions = React.lazy(() => import('../pages/HIS/AdminActions'))
const PriceListTypes = React.lazy(() =>
  import('../pages/HIS/PriceListTypesMain')
)
const Shifts = React.lazy(() => import('../pages/HIS/Shifts'))
const GeneralFormEntries = React.lazy(() =>
  import('../pages/HIS/GeneralFormEntries')
)
const VisitFormEntries = React.lazy(() =>
  import('../pages/HIS/VisitFormEntries')
)
const Roles = React.lazy(() => import('../pages/HIS/Roles'))
const Modules = React.lazy(() => import('../pages/HIS/Module'))
const Permisions = React.lazy(() => import('../pages/HIS/Permisions'))
const SearchPatients = React.lazy(() =>
  import('../pages/HIS/SearchPatientsPage')
)
const HandOver = React.lazy(() => import('../pages/HIS/HandOver'))
const Appointments = React.lazy(() => import('../pages/HIS/Appointments'))
const CreateNewAppointment = React.lazy(() =>
  import('../pages/HIS/CreateNewAppointment')
)
const CreateAppointmentFormPage = React.lazy(() =>
  import('../pages/HIS/CreateAppointmentFormPage')
)
const CreateAppointmentFromVisitPage = React.lazy(() =>
  import('../pages/HIS/CreateAppointmentFromVisitPage')
)
const EditAppointmentPage = React.lazy(() =>
  import('../pages/HIS/EditAppointmentPage')
)
const PrintInvoice = React.lazy(() => import('../pages/HIS/PrintInvoice'))
const PatientOpdSummary = React.lazy(() =>
  import('../pages/HIS/patient-profiling/PatientOpdSummary')
)
const PatientOverview = React.lazy(() =>
  import('../pages/HIS/patient-profiling/PatientOverview')
)
const PatientCurrentMedications = React.lazy(() =>
  import('../pages/HIS/patient-profiling/PatientCurrentMedications')
)
const PatientEncounterHistory = React.lazy(() =>
  import('../pages/HIS/patient-profiling/PatientEncounterHistory')
)
const PatientOrders = React.lazy(() =>
  import('../pages/HIS/patient-profiling/PatientOrders')
)
const PatientClinicalDocuments = React.lazy(() =>
  import('../pages/HIS/patient-profiling/PatientClinicalDocuments')
)
const PatientEMR = React.lazy(() =>
  import('../pages/HIS/patient-profiling/PatientEMR')
)
const EMRForm = React.lazy(() =>
  import('../components/his/patient-profile/EMRForm')
)
const PatientBillingReports = React.lazy(() =>
  import('../pages/HIS/patient-profiling/BillingReports')
)
const SickLeave = React.lazy(() =>
  import('../pages/HIS/patient-profiling/SickLeave')
)
const ReferralForms = React.lazy(() =>
  import('../pages/HIS/patient-profiling/ReferralForms')
)
const PharmacyReports = React.lazy(() => import('../pages/HIS/PharmacyReports'))
const PatientHistory = React.lazy(() =>
  import('../pages/HIS/patient-profiling/PatientHistory')
)
const PatientAuditHistory = React.lazy(() =>
  import('../pages/HIS/patient-profiling/PatientAuditHistory')
)
const PatientHistoryDetailPage = React.lazy(() =>
  import('../pages/HIS/patient-profiling/PatientHistoryDetailPage')
)
const DepositHistory = React.lazy(() =>
  import('../pages/HIS/patient-profiling/DepositHistory')
)
const CreditHistory = React.lazy(() =>
  import('../pages/HIS/patient-profiling/CreditHistory')
)
const PatientCreditHistory = React.lazy(() =>
  import('../pages/HIS/patient-profiling/PatientCreditHistory')
)
const EpisodeLimitHistory = React.lazy(() =>
  import('../pages/HIS/patient-profiling/EpisodeLimitHistory')
)
const Emergency = React.lazy(() => import('../pages/HIS/Emergency'))
const Inventory = React.lazy(() => import('../pages/HIS/Inventory'))
const ADT = React.lazy(() => import('../pages/HIS/ADT'))
const DoctorNotes = React.lazy(() =>
  import('../pages/HIS/patient-profiling/DoctorNotes')
)
const AppointmentTypes = React.lazy(() =>
  import('../pages/HIS/AppointmentTypes')
)
const IcdManagement = React.lazy(() => import('../pages/HIS/IcdManagement'))
const SfdaManagement = React.lazy(() => import('../pages/HIS/SfdaManagement'))
const PaymentCardTypes = React.lazy(() =>
  import('../pages/HIS/PaymentCardTypes')
)
const ShiftScheduling = React.lazy(() => import('../pages/HIS/ShiftScheduling'))
const BedManagement = React.lazy(() => import('../pages/HIS/BedManagement'))
const CreateWard = React.lazy(() => import('../pages/HIS/CreateWard'))
const AddPatient = React.lazy(() => import('../pages/HIS/AddPatient'))
const CreateAdmission = React.lazy(() => import('../pages/HIS/CreateAdmission'))
const PractitionerAdmissions = React.lazy(() =>
  import('../pages/HIS/PractitionerAdmissions')
)
const QueueManagement = React.lazy(() => import('../pages/QueueManagement'))
const PharmacyGroupItems = React.lazy(() =>
  import('../pages/HIS/patient-profiling/reports/PharmacyGroupItems')
)

const EditInvoicePage = React.lazy(() =>
  import('../pages/HIS/billing/EditInvoicePage')
)
const EditDepositInvoice = React.lazy(() =>
  import('../pages/HIS/billing/EditDepositInvoice')
)

const EditWithdrawInvoice = React.lazy(() =>
  import('../pages/HIS/billing/EditWithdrawInvoice')
)
const DailyInvoiceReport = React.lazy(() =>
  import('../pages/HIS/DailyInvoiceReport')
)
// NEW REFACTORED REPORT - Support multiple concurrent jobs
const InvoicesDetailedReportAsync = React.lazy(() =>
  import('../pages/HIS/InvoicesDetailedReportAsyncNew')
)

const VatReturnSummay = React.lazy(() => import('../pages/HIS/VatReturnSummay'))
const VatFilingOverviewReport = React.lazy(() => import('../pages/HIS/VatFilingOverviewReport'))
const VatFinalReport = React.lazy(() => import('../pages/HIS/VatFinalReport'))
const NonSaudiZeroVatAuditReport = React.lazy(() => import('../pages/HIS/NonSaudiZeroVatAuditReport'))
const VatReturnDetailReport = React.lazy(() => import('../pages/HIS/VatReturnDetailReport'))

const SalesReportSummary = React.lazy(() =>
  import('../pages/HIS/SalesReportSummary')
)

const DailyCollectionReport = React.lazy(() =>
  import('../pages/HIS/DailyCollectionReport')
)

const ZatcaStatsPage = React.lazy(() =>
  import('../pages/HIS/billing/ZatcaStatsPage')
)

const GLPosting = React.lazy(() =>
  import('../components/his/billingReports.js/GLPosting')
)
const PaymentMethodsReport = React.lazy(() =>
  import('../pages/HIS/PaymentMethodsReport')
)
const DoctorWiseCostReport = React.lazy(() =>
  import('../pages/HIS/DoctorWiseCostReport')
)
const PatientBillingHistory = React.lazy(() =>
  import('../pages/HIS/PatientBillingHistory')
)
const RabbitmqFailureLogs = React.lazy(() =>
  import('../pages/HIS/RabbitmqFailureLogs')
)

const InsuranceClaimSummaryPage = React.lazy(() =>
  import('../pages/HIS/billing/InsuranceClaimSummaryPage')
)
const InsuranceClaimInvoiceDetailsPage = React.lazy(() =>
  import('../pages/HIS/billing/InsuranceClaimInvoiceDetailsPage')
)
const P2PInsuranceInvoice = React.lazy(() =>
  import('../pages/HIS/billing/P2PInsuranceInvoice')
)
const CreditCompanyInsuranceInvoicePrint = React.lazy(() =>
  import('../pages/HIS/billing/CreditCompanyInsuranceInvoicePrint')
)
const NursingStation = React.lazy(() => import('../pages/HIS/NursingStation'))
const ArchivedVisits = React.lazy(() => import('../pages/HIS/ArchivedVisits'))
const PatientAllReports = React.lazy(() =>
  import('../pages/HIS/PatientAllReports')
)
const DentalBilling = React.lazy(() =>
  import('../pages/HIS/patient-profiling/DentalBilling')
)
const OrderDispatchLogs = React.lazy(() =>
  import('../pages/HIS/OrderDispatchLogs')
)
const PatientAlerts = React.lazy(() => import('../pages/HIS/PatientAlerts'))
const CorrectionHistoryPage = React.lazy(() =>
  import('../components/his/claimgeneration/CorrectionHistoryPage')
)
const AdminAuditLogs = React.lazy(() => import('../pages/HIS/AdminAuditLogs'))
const NahdiInvoiceLogs = React.lazy(() => import('../pages/HIS/NahdiInvoiceLogs'))
const NahdiPrescriptionResults = React.lazy(() =>
  import('../pages/HIS/NahdiPrescriptionResults')
)
const RCMPreAuthLogs = React.lazy(() => import('../pages/HIS/RCMPreAuthLogs'))
const RCMPreAuthLogDetails = React.lazy(() => import('../pages/HIS/RCMPreAuthLogDetails'))
const RCMWebhookApprovalLogs = React.lazy(() => import('../pages/HIS/RCMWebhookApprovalLogs'))
const RCMWebhookApprovalLogDetails = React.lazy(() => import('../pages/HIS/RCMWebhookApprovalLogDetails'))
const EditRCMWebhookApprovalLog = React.lazy(() => import('../pages/HIS/EditRCMWebhookApprovalLog'))

const AuthenticatedRoutes = () => {
  const { user } = useSelector(state => state?.auth)
  const isSuperAdmin = user?.role?.name_en === 'Super Admin'

  const routesConfig = [
    {
      path: '/dashboard',
      component:
        isSuperAdmin ? (
          <Navigate to='/system-health-dashboard' replace />
        ) : user?.role?.id == 6 ? (
          <SupplyChainDashboard />
        ) : (
          <ReceptionDashboard />
        ),
      moduleName: 'dashboard',
      permission: 'get'
    },
    {
      path: '/system-health-dashboard',
      component: isSuperAdmin ? (
        <SystemHealthDashboard />
      ) : (
        <Navigate to='/dashboard' replace />
      ),
      moduleName: 'dashboard',
      permission: 'get'
    },
    {
      path: '/minio',
      component: isSuperAdmin ? <MinioManager /> : <Navigate to='/dashboard' replace />,
      moduleName: 'dashboard',
      permission: 'get'
    },
    {
      path: '/minio/:bucketName',
      component: isSuperAdmin ? <MinioManager /> : <Navigate to='/dashboard' replace />,
      moduleName: 'dashboard',
      permission: 'get'
    },
    {
      path: '/visits',
      component: <Visits />,
      moduleName: 'visit',
      permission: 'get'
    },
    {
      path: '/nursing-station',
      component: <NursingStation />,
      moduleName: 'visit',
      permission: 'get'
    },
    {
      path: '/approval-management',
      component: <ApprovalManagement />,
      moduleName: 'approval_management',
      permission: 'get'
    },
    {
      path: '/emr-history',
      component: <EmrHistoryPage />,
      moduleName: 'emr',
      permission: 'get'
    },
    {
      path: '/billing/update-history',
      component: <InvoiceAuditPage />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/create-visit',
      component: <CreateVisits />,
      moduleName: 'visit',
      permission: 'create'
    },
    {
      path: '/create-visit-without-slot',
      component: <CreateWithoutSlot />,
      moduleName: 'visit',
      permission: 'create'
    },
    {
      path: '/patient-active-orders',
      component: <PatientActiveOrders />,
      moduleName: 'visit',
      permission: 'get'
    },
    {
      path: '/pay-bill',
      component: <CreateVisits />,
      moduleName: 'visit',
      permission: 'update'
    },
    {
      path: '/orders',
      component: <Orders />,
      permission: 'get',
      moduleName: 'order'
    },
    {
      path: '/create-order',
      component: <CreateOrder />,
      moduleName: 'order',
      permission: 'create'
    },
    {
      path: '/create-special-visit',
      component: <CreateSpecialVisit />,
      moduleName: 'special-visit',
      permission: 'create'
    },
    {
      path: '/appointment-history/:id',
      component: <AppointmentHistoryPage />,
      moduleName: 'appointments',
      permission: 'get'
    },
    {
      path: '/orders/:id',
      component: <OrderDetails />,
      permission: 'get',
      moduleName: 'order'
    },
    {
      path: '/patient-profile/appointments',
      component: <ProfileAppointments />,
      permission: 'get',
      moduleName: 'appointments'
    },
    {
      path: '/patient-profile/visits',
      component: <ProfileVisits />,
      permission: 'get',
      moduleName: 'visit'
    },
    {
      path: '/search-patients',
      component: <SearchPatients />,
      moduleName: 'visit',
      permission: 'get'
    },
    {
      path: '/beneficiary',
      component: <Beneficiary />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-bulk-upload',
      component: <PatientBulkUpload />,
      moduleName: 'patient',
      permission: 'create'
    },
    {
      path: '/create-beneficiary',
      component: <CreateBeneficiary />,
      moduleName: 'patient',
      permission: 'create'
    },
    {
      path: '/edit-beneficiary',
      component: <CreateBeneficiary />,
      moduleName: 'patient',
      permission: 'update'
    },
    {
      path: '/beneficiary/:id',
      component: <BeneficiaryDetails />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-alerts/:id',
      component: <PatientAlerts />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/eligibility',
      component: <Eligibility />,
      moduleName: 'eligibility',
      permission: 'get'
    },
    {
      path: '/practitioners',
      component: <Physicians />,
      moduleName: 'practitioner',
      permission: 'get'
    },
    {
      path: '/payers',
      component: <Payers />,
      moduleName: 'payer',
      permission: 'get'
    },
    {
      path: '/payers/:payerId/policies',
      component: <PayerPolicyBenefits />,
      moduleName: 'payer',
      permission: 'get'
    },
    {
      path: '/payers/:payerId/policies/:policyId/benefits',
      component: <PolicyBenefits />,
      moduleName: 'payer',
      permission: 'get'
    },
    {
      path: '/drivers',
      component: <Drivers />,
      moduleName: 'driver',
      permission: 'get'
    },
    {
      path: '/nurses',
      component: <Nurses />,
      moduleName: 'nurse',
      permission: 'get'
    },
    {
      path: '/insurance-policy',
      component: <InsurancePolicy />,
      moduleName: 'insurance_policy',
      permission: 'get'
    },
    {
      path: '/price-list',
      component: <PriceLists />,
      moduleName: 'pricelists',
      permission: 'get'
    },
    {
      path: '/price-list-types',
      component: <PriceListTypes />,
      moduleName: 'pricelist_types',
      permission: 'get'
    },
    {
      path: '/create-price-list',
      component: <CreatePriceList />,
      moduleName: 'pricelists',
      permission: 'create'
    },
    {
      path: '/forms-creation',
      component: <FormsCreation />,
      moduleName: 'forms-creation',
      permission: 'get'
    },
    {
      path: '/forms-list',
      component: <DynamicFormsList />,
      moduleName: 'forms-creation',
      permission: 'get'
    },
    {
      path: '/view-form-details/:id',
      component: <ViewFormDetails />,
      moduleName: 'forms-creation',
      permission: 'get'
    },
    {
      path: '/staff-management',
      component: <Staff />,
      moduleName: 'staff',
      permission: 'get'
    },
    {
      path: '/staff-management/form',
      component: <StaffFormPage />,
      moduleName: 'staff',
      permission: 'create'
    },
    {
      path: '/management',
      component: <AdminActions />,
      moduleName: 'management',
      permission: 'get',
      allowCallCenter: true
    },
    {
      path: '/patient-billing-history/:id',
      component: <PatientBillingHistory />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/archived-visits',
      component: <ArchivedVisits />,
      moduleName: 'visit',
      permission: 'get'
    },
    {
      path: '/shift-management',
      component: <Shifts />,
      moduleName: 'shift',
      permission: 'get'
    },
    {
      path: '/general-form-entries',
      component: <GeneralFormEntries />,
      permission: 'get',
      moduleName: 'patient'
    },
    {
      path: '/roles',
      component: <Roles />,
      moduleName: 'role',
      permission: 'get'
    },
    {
      path: '/modules',
      component: <Modules />,
      moduleName: 'module',
      permission: 'get'
    },
    {
      path: '/permissions',
      component: <Permisions />,
      moduleName: 'permission',
      permission: 'get'
    },
    {
      path: '/hand-over',
      component: <HandOver />,
      moduleName: 'counter',
      permission: 'get'
    },
    {
      path: '/billing',
      component: <Billing />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/deposit-list',
      component: <PatientsDepositList />,
      moduleName: 'deposit',
      permission: 'get'
    },
    {
      path: '/patients-credit-list',
      component: <PatientsCreditList />,
      moduleName: 'patientCreditBalance',
      permission: 'get'
    },
    {
      path: '/billing/edit-invoice/:invoiceNumber',
      component: <EditInvoicePage />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/billing/edit-deposit-invoice/:invoiceNumber',
      component: <EditDepositInvoice />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/billing/edit-withdraw-invoice/:invoiceNumber',
      component: <EditWithdrawInvoice />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/his/daily-invoice-report',
      component: <DailyInvoiceReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/his/invoice-detailed-report-async',
      component: <InvoicesDetailedReportAsync />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/his/daily-collection-report',
      component: <DailyCollectionReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/gl-posting',
      component: <GLPosting />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/payment-methods-report',
      component: <PaymentMethodsReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/zatca-stats',
      component: <ZatcaStatsPage />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/appointments',
      component: <Appointments />,
      moduleName: 'appointments',
      permission: 'get'
    },
    {
      path: '/create-appointment',
      component: <CreateNewAppointment />,
      moduleName: 'appointments',
      permission: 'create'
    },
    {
      path: '/create-appointment-form',
      component: <CreateAppointmentFormPage />,
      moduleName: 'appointments',
      permission: 'create'
    },
    {
      path: '/create-bulk-appointment',
      component: <CreateAppointmentFormPage isBulkMode={true} />,
      moduleName: 'appointments',
      permission: 'create'
    },
    {
      path: '/create-appointment-from-visit',
      component: <CreateAppointmentFromVisitPage />,
      moduleName: 'appointments',
      permission: 'create'
    },
    {
      path: '/edit-appointment/:id',
      component: <EditAppointmentPage />,
      moduleName: 'appointments',
      permission: 'update'
    },
    {
      path: '/appointment-types',
      component: <AppointmentTypes />,
      moduleName: 'appointmentTypes',
      permission: 'get'
    },
    {
      path: '/admin-actions/icd',
      component: <IcdManagement />,
      moduleName: 'icd',
      permission: 'get'
    },
    {
      path: '/admin-actions/sfda',
      component: <SfdaManagement />,
      moduleName: 'sfda',
      permission: 'get'
    },
    {
      path: '/payment-card-types',
      component: <PaymentCardTypes />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/print-invoice/:invoice_number',
      component: <PrintInvoice />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/patient-profile/summary',
      component: <PatientOpdSummary />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-profile/overview',
      component: <PatientOverview />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/claims/batches/:batchId',
      component: <ClaimBatchDetails />,
      moduleName: 'cliamgeneration',
      permission: 'get'
    },
    {
      path: '/claims',
      component: <Claims />,
      moduleName: 'cliamgeneration',
      permission: 'get'
    },
    {
      path: '/HIS-claim-generation',
      component: <ClaimGeneration />,
      moduleName: 'cliamgeneration',
      permission: 'get'
    },
    {
      path: '/pharmacy-claim-generation',
      component: <PharmacyClaimGeneration />,
      moduleName: 'cliamgeneration',
      permission: 'get'
    },
    {
      path: '/bulk-claims-batches',
      component: <BulkClaimsBatches />,
      moduleName: 'cliamgeneration',
      permission: 'get'
    },
    {
      path: '/claim-edit',
      component: <EditClaim />,
      moduleName: 'cliamgeneration',
      permission: 'update'
    },
    {
      path: '/claim-list',
      component: <ClaimList />,
      moduleName: 'cliamgeneration',
      permission: 'get'
    },
    {
      path: '/claim-details',
      component: <ClaimDetails />,
      moduleName: 'cliamgeneration',
      permission: 'get'
    },
    {
      path: '/patient-profile/update-history',
      component: <PatientAuditHistory />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-profile/doctor-notes',
      component: <DoctorNotes />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-profile/current-medications',
      component: <PatientCurrentMedications />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-profile/form-entries',
      component: <VisitFormEntries />,
      moduleName: 'general-form-entries',
      permission: 'get'
    },
    {
      path: '/patient-profile/encounter-history',
      component: <PatientEncounterHistory />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-profile/orders',
      component: <PatientOrders />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-profile/medical-reports',
      component: <EmrNewMedicalReportPage />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-profile/clinical-documents',
      component: <PatientClinicalDocuments />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-profile/emr',
      component: <PatientEMR />,
      moduleName: 'emr',
      permission: 'get'
    },
    {
      path: '/patient-profile/create-emr',
      component: <EMRForm />,
      moduleName: 'emr',
      permission: 'create'
    },
    {
      path: '/patient-profile/edit-emr',
      component: <EMRForm />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-profile/lab-orders',
      component: <LabOrders />,
      moduleName: 'labOrders',
      permission: 'get'
    },
    {
      path: '/patient-profile/radiology-orders',
      component: <RadiologyOrders />,
      moduleName: 'labOrders',
      permission: 'get'
    },
    {
      path: '/patient-profile/view-lab-orders/:id',
      component: <ViewLabOrder />,
      moduleName: 'labOrders',
      permission: 'get'
    },
    {
      path: '/patient-profile/track-orders/:order',
      component: <TrackingPage />,
      moduleName: 'labOrders',
      permission: 'get'
    },
    {
      path: '/patient-profile/dental-billing',
      component: <DentalBilling />,
      moduleName: 'departmentInvoices',
      permission: 'get'
    },
    {
      path: '/patient-profile/pharmacy-group-items',
      component: <PharmacyGroupItems />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/billing-reports',
      component: <PatientBillingReports />,
      moduleName: 'Reports',
      permission: 'get'
    },
    {
      path: '/user-collection',
      component: <UserCollectionReport />,
      moduleName: 'UserCollection',
      permission: 'get'
    },
    {
      path: '/invoices',
      component: <InvoiceReport />,
      moduleName: 'UserCollection',
      permission: 'get'
    },
    {
      path: '/doctor-wise-income-summary',
      component: <DoctorWiseReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/doctor-schedule-report',
      component: <DoctorScheduleReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/vat-return-summary',
      component: <VatReturnSummay />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/vat-filing-overview-report',
      component: <VatFilingOverviewReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/vat-final-report',
      component: <VatFinalReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/non-saudi-zero-vat-audit-report',
      component: <NonSaudiZeroVatAuditReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/vat-return-detail-report',
      component: <VatReturnDetailReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/sales-report',
      component: <SalesReportSummary />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/doctor-wise-cost-report',
      component: <DoctorWiseCostReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/billing/insurance-claim-invoice/new',
      component: <InsuranceClaimSummaryPage />,
      moduleName: 'billing',
      permission: 'create'
    },
    {
      path: '/billing/insurance-claim-invoice/:id',
      component: <InsuranceClaimInvoiceDetailsPage />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/billing/insurance-claim-invoice/print',
      component: <P2PInsuranceInvoice />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/billing/insurance-claim-credit-company-invoice/print',
      component: <CreditCompanyInsuranceInvoicePrint />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/summary-report',
      component: <DoctorDepartmentSummaryReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/payers-summary-report',
      component: <PayersSummaryReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/payer-report',
      component: <PayerReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/policy-report',
      component: <PolicyReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/pre-claim-submission-report',
      component: <PreClaimSubmissionReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/patient-reports',
      component: <PatientReports />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/department-wise-patient-count',
      component: <DepartmentWisePatientReport />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/drs-patient-report',
      component: <DrsPatientReport />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/drs-patient-item-wise-report',
      component: <DrsPatientItemWiseReportAsync />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/clinical-reports',
      component: <EMRReport />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/item-wise-summary-report',
      component: <ItemWiseSummaryReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/item-wise-detailed-report',
      component: <ItemWiseDetailedReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/lab-radiology-summary-report',
      component: <LabRadiologySummaryReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/lab-radiology-item-wise-report',
      component: <LabRadiologyItemWiseReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/patient-analysis-report',
      component: <PatientAnalysisReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/sales-date-wise-report',
      component: <SalesDateWiseReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/refund-report',
      component: <RefundReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/practitioner-item-summary-report',
      component: <PractitionerItemSummaryReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/residential-report',
      component: <ResidentialReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/approval-report',
      component: <ApprovalReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/not-approved-audits',
      component: <NotApprovedAuditsReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/payer-stats-report',
      component: <PayerStatsReport />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/pharmacy-reports',
      component: <PharmacyReports />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/pharmacy-reports/external',
      component: <ExternalPharmacySalesReportAsync />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/pharmacy-reports/internal',
      component: <InternalPharmacySalesReportAsync />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/reports/lab',
      component: <LabReportPage />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/reports/radiology',
      component: <RadiologyReportPage />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/reports/high-bmi-patients',
      component: <HighBmiPatientReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/reports/no-show-patients',
      component: <NoShowPatientReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/reports/vaccine-status',
      component: <VaccineStatusReport />,
      moduleName: 'invoices',
      permission: 'get'
    },
    {
      path: '/reports/icd-inactive',
      component: <ICDInactiveReportPage />,
      moduleName: 'emr',
      permission: 'get'
    },
    {
      path: '/reports/icd-inactive-manager',
      component: <IcdInactiveReportManager />,
      moduleName: 'emr',
      permission: 'get'
    },
    {
      path: '/reports/icd-test',
      component: <IcdReportsTest />,
      moduleName: 'emr',
      permission: 'get'
    },
    {
      path: '/icd-bulk-replace',
      component: <ICDBulkReplacePage />,
      moduleName: 'emr',
      permission: 'get'
    },
    {
      path: '/reports/icd-bulk-replace/logs',
      component: <ICDBulkReplaceLogsPage />,
      moduleName: 'emr',
      permission: 'get'
    },
    {
      path: '/reports/item-field-replace',
      component: <ItemFieldReplacePage />,
      moduleName: 'emr',
      permission: 'get'
    },
    {
      path: '/reports/item-field-replace/create',
      component: <ItemFieldReplaceCreatePage />,
      moduleName: 'emr',
      permission: 'get'
    },
    {
      path: '/emergency',
      component: <Emergency />,
      moduleName: 'emergency',
      permission: 'get'
    },
    {
      path: '/patient-profile/sick-leave',
      component: <SickLeave />,
      moduleName: 'leave',
      permission: 'get'
    },
    {
      path: '/patient-profile/referral-certificate',
      component: <ReferralCertificatePage />,
      moduleName: 'referral_certificate',
      permission: 'get'
    },
    {
      path: '/patient-profile/attendance-certificate',
      component: <AttendanceCertificatePage />,
      moduleName: 'attendance_certificate',
      permission: 'get'
    },
    {
      path: '/patient-profile/fit-to-travel',
      component: <FitToTravelPage />,
      moduleName: 'fit_to_travel',
      permission: 'get'
    },
    {
      path: '/patient-profile/accompany-certificate',
      component: <AccompanyCertificatePage />,
      moduleName: 'accompany_certificate',
      permission: 'get'
    },
    {
      path: '/patient-profile/fit-to-rejoin',
      component: <FitToRejoinPage />,
      moduleName: 'fit_to_rejoin',
      permission: 'get'
    },
    {
      path: '/patient-profile/referral-forms',
      component: <ReferralForms />,
      moduleName: 'referral_form',
      permission: 'get'
    },
    {
      path: '/patient-profile/patient-history',
      component: <PatientHistory />,
      moduleName: 'patientHistory',
      permission: 'get'
    },
    {
      path: '/patient-history-detail/:id',
      component: <PatientHistoryDetailPage />,
      moduleName: 'patientHistory',
      permission: 'get'
    },
    {
      path: '/patient-profile/deposit-history',
      component: <DepositHistory />,
      moduleName: 'deposit',
      permission: 'get'
    },
    {
      path: '/patient-profile/patient-credit-history',
      component: <PatientCreditHistory />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/patient-profile/episode-limit-history',
      component: <EpisodeLimitHistory />,
      moduleName: 'visit',
      permission: 'get'
    },
    {
      path: '/patient-profile/in-patient',
      component: <InPatientMain />,
      moduleName: 'leave',
      permission: 'get'
    },
    {
      path: '/help-desk',
      component: <HelpDesk />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/cssd',
      component: <CSSD />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/medical-records',
      component: <MedicalRecords />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/operation-theatre',
      component: <OperationTheatre />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/vaccination',
      component: <Vaccination />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/bio-medical',
      component: <BioMedical />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/adt',
      component: <ADT />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/procurement',
      component: <Procurement />,
      moduleName: 'procurement',
      permission: 'get'
    },
    {
      path: '/procurement-add-purchase-order',
      component: <AddPurchaseOrder />,
      moduleName: 'procurement',
      permission: 'get'
    },
    {
      path: '/procurement-add-reciept',
      component: <AddReciept />,
      moduleName: 'procurement',
      permission: 'get'
    },
    {
      path: '/procurement-request-quotation',
      component: <RequestQuotation />,
      moduleName: 'procurement',
      permission: 'get'
    },
    {
      path: '/fms-operations',
      component: <FmsOperations />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/queue-management',
      component: <QueueManagement />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/queue-dashboard',
      component: <QueueDashboard />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/department',
      component: <Department />,
      moduleName: 'department',
      permission: 'get'
    },
    {
      path: '/specialities',
      component: <Specialities />,
      moduleName: 'speciality',
      permission: 'get'
    },
    {
      path: '/inventory',
      component: <Inventory />,
      moduleName: 'inventory',
      permission: 'get'
    },

    {
      path: '/requisition-direct-dispatch',
      component: <DirectDispatchFrom />,
      moduleName: 'inventory',
      permission: 'get'
    },
    {
      path: '/requisition-request-purchase',
      component: <PurchaseRequestForm />,
      moduleName: 'inventory',
      permission: 'get'
    },
    {
      path: '/requisition-donate-form',
      component: <DonateForm />,
      moduleName: 'inventory',
      permission: 'get'
    },
    {
      path: '/return-to-vendor',
      component: <ReturnToVendor />,
      moduleName: 'inventory',
      permission: 'get'
    },
    {
      path: '/manage-stock',
      component: <StockManage />,
      moduleName: 'inventory',
      permission: 'get'
    },
    {
      path: '/view/price-list',
      component: <PriceListViewPage />,
      moduleName: 'pricelists',
      permission: 'get'
    },
    {
      path: '/pricelist-audits',
      component: <PriceListAuditHistory />,
      moduleName: 'pricelists',
      permission: 'get'
    },
    {
      path: '/shift-scheduling',
      component: <ShiftScheduling />,
      moduleName: 'shift',
      permission: 'get'
    },
    {
      path: '/create-ward',
      component: <CreateWard />,
      moduleName: 'ward',
      permission: 'create'
    },
    {
      path: '/add-patient',
      component: <AddPatient />,
      moduleName: 'patientAdmission',
      permission: 'create'
    },
    {
      path: '/bed-management',
      component: <BedManagement />,
      moduleName: 'bed',
      permission: 'get'
    },
    {
      path: '/addmission-office',
      component: <WardManagement />,
      moduleName: 'ward',
      permission: 'get'
    },
    {
      path: '/practitioner-admissions',
      component: <PractitionerAdmissions />,
      moduleName: 'patientAdmission',
      permission: 'get'
    },
    {
      path: '/patient-profile/create-admission',
      component: <CreateAdmission />,
      moduleName: 'visit',
      permission: 'get'
    },
    {
      path: '/create-admission',
      component: <CreateAdmission />,
      moduleName: 'visit',
      permission: 'get'
    },
    {
      path: '/settings',
      component: <Settings />,
      moduleName: 'settings',
      permission: 'get'
    },
    {
      path: '/medical-report-settings',
      component: <MedicalReportSettings />,
      moduleName: 'settings',
      permission: 'get'
    },
    {
      path: '/visit-history/:beneficiaryName',
      component: <VisitHistory />,
      moduleName: 'visit',
      permission: 'get'
    },
    {
      path: '/visit-history-detail/:beneficiaryName',
      component: <VisitHistoryDetailPage />,
      moduleName: 'visit',
      permission: 'get'
    },
    {
      path: '/rabbitmq-failure-logs',
      component: <RabbitmqFailureLogs />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/order-dispatch-logs',
      component: <OrderDispatchLogs />,
      moduleName: 'billing',
      permission: 'get'
    },
    {
      path: '/patient-profile/all-reports',
      component: <PatientAllReports />,
      moduleName: 'patient',
      permission: 'get'
    },
    {
      path: '/correction-history',
      component: <CorrectionHistoryPage />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/admin-actions/pre-auth-logs',
      component: <RCMPreAuthLogs />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/admin-actions/pre-auth-logs/:id',
      component: <RCMPreAuthLogDetails />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/admin-actions/audit-logs',
      component: <AdminAuditLogs />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/admin-actions/episode-limit-history',
      component: <EpisodeLimitHistory />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/admin-actions/third-party-pharmacy-logs',
      component: <NahdiInvoiceLogs />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/admin-actions/nahdi-prescription-results',
      component: <NahdiPrescriptionResults />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/admin-actions/webhook-approval-logs',
      component: <RCMWebhookApprovalLogs />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/admin-actions/webhook-approval-logs/:id',
      component: <RCMWebhookApprovalLogDetails />,
      moduleName: 'management',
      permission: 'get'
    },
    {
      path: '/admin-actions/webhook-approval-logs/:id/edit',
      component: <EditRCMWebhookApprovalLog />,
      moduleName: 'management',
      permission: 'get'
    }
  ]

  const location = useLocation()
  const path = location.pathname
  const LayoutWrapper =
    path?.includes('/patient-profile') && !path?.includes('/all-reports')
      ? PatientProfilingLayout
      : path === '/queue-dashboard' || path?.includes('/all-reports')
        ? React.Fragment
        : AuthenticatedLayout

  return (
    <LayoutWrapper>
      <Routes>
        {routesConfig.map(({ path, component, moduleName, permission, allowCallCenter }) => (
          <Route
            key={path}
            path={path}
            element={
              path === '/queue-dashboard' ? (
                <ProtectedRoute moduleName={moduleName} permission={permission} allowCallCenter={allowCallCenter}>
                  <div className='min-h-screen bg-gray-100'>{component}</div>
                </ProtectedRoute>
              ) : (
                <ProtectedRoute moduleName={moduleName} permission={permission} allowCallCenter={allowCallCenter}>
                  {component}
                </ProtectedRoute>
              )
            }
          />
        ))}
        <Route
          path='*'
          element={
            <Navigate
              to={
                isSuperAdmin
                  ? '/system-health-dashboard'
                  : user?.role?.name_en === 'Accountant'
                    ? '/hand-over'
                    : user?.role?.name_en === 'Rcm Assistant'
                      ? '/approval-management'
                      : user?.role?.name_en === 'Call Center'
                        ? '/appointments'
                        : user?.role?.id == 4
                          ? '/visits'
                          : '/dashboard'
              }
              replace
            />
          }
        />
      </Routes>
    </LayoutWrapper>
  )
}

export default AuthenticatedRoutes



